import React from 'react';
 
const DancePage = () => {
    return (
      <div
        className="video mt-5"
        style={{
               position: "relative",
               paddingBottom: "56.25%" /* 16:9 */,
               paddingTop: 25,
               height: 0
             }}
      >
        <iframe 
         style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "60%",
              height: "60%",
              marginLeft: 100,
              marginTop: 110,
              }}
              
              src="https://www.youtube.com/embed/Ps2Jc28tQrw?autoplay=1" 
              frameBorder='0'
              allow='autoplay; encrypted-media'
              allowFullScreen
              title='video'>
        </iframe>     
    <h3 style={{fontSize: 50, paddingTop: 5, paddingLeft: 200}}>React Dance</h3>

    <div style={{marginLeft: 1050, marginTop: 110}}>
      <table style={{backgroundColor: 'black'}}>
        <tr>
          <th>Image</th>
          <th>Artist</th>
          <th>Song</th>
          <th>YouTube</th>
        </tr>

        <tr>
          <td><img id="tableimg" src="https://upload.wikimedia.org/wikipedia/en/thumb/3/3b/2_Unlimited_No_Limit_Cover_-_Europe.jpg/220px-2_Unlimited_No_Limit_Cover_-_Europe.jpg"/></td>
          <td><a href="https://en.wikipedia.org/wiki/No_Limit_(2_Unlimited_song)">2 Unlimited</a></td>
          <td>No Limit</td>
          <td><iframe width="80" height="45" src="https://www.youtube.com/embed/qM5W7Xn7FiA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
        </tr>

        <tr>
          <td><img id="tableimg" src="https://upload.wikimedia.org/wikipedia/en/7/74/Finally_CeCe_Peniston_US_cover_art.jpg"/></td>
          <td><a href="https://en.wikipedia.org/wiki/Finally_(CeCe_Peniston_song)">CeCe Peniston</a></td>
          <td>Finally</td>
          <td><iframe width="80" height="45" src="https://www.youtube.com/embed/xk8mm1Qmt-Y" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
        </tr>

        <tr>
          <td><img id="tableimg" src="https://images-na.ssl-images-amazon.com/images/I/51rvqM6RU9L._AC_.jpg"/></td>
          <td><a href="https://www.amazon.ca/BERRI-SUNSHINE-AFTER-RAIN-Berri/dp/B0000570OM">Berri</a></td>
          <td>The Sunshine After The Rain</td>
          <td><iframe width="80" height="45" src="https://www.youtube.com/embed/FsEHPYVfrxs" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
        </tr>

        <tr>
          <td><img id="tableimg" src="https://upload.wikimedia.org/wikipedia/en/e/e2/Gypsy_Woman_%28She%27s_Homeless%29_%28Crystal_Waters_single_-_cover_art%29.jpg"/></td>
          <td><a href="https://en.wikipedia.org/wiki/Gypsy_Woman_(Crystal_Waters_song)">Crystal Waters</a></td>
          <td>Gypsy Woman</td>
          <td><iframe width="80" height="45" src="https://www.youtube.com/embed/_KztNIg4cvE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
        </tr>

        <tr>
          <td><img id="tableimg" src="https://www.songfacts.com/img-artalbums-145-1c3a6e4e8894d5edac8d832300e3e1b8.png"/></td>
          <td><a href="https://www.songfacts.com/facts/corona/the-rhythm-of-the-night">Corona</a></td>
          <td>The Rhythm of the Night</td>
          <td><iframe width="80" height="45" src="https://www.youtube.com/embed/OnT58cIJSpw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></td>
        </tr>
      </table>
    </div>

</div>
    );
}
 
export default DancePage;